import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  urlConveniosParceiros = '';

  constructor(private httpCliente: HttpClient) {
    this.urlConveniosParceiros = `${environment.apiUrl}/convenios`;
  }

  buscarDescricaoConvenio(idConvenio: number, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlConveniosParceiros}/fotos/convenios/${idConvenio}`, httpHeaders);
  }

  buscarDescricoes(idConvenio: number, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlConveniosParceiros}/convenios/descricoes/${idConvenio}`, httpHeaders);
  }

  buscarTodosParceiros(token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlConveniosParceiros}/convenios`, httpHeaders);
  }
}

